export default __webpack_public_path__ + "assets/peoples.9c374609.svg";